// extracted by mini-css-extract-plugin
export default {"pageContainer":"Home_pageContainer__odPO2","contentWrapper":"Home_contentWrapper__1a2Yn","header":"Home_header__6-AUA","title":"Home_title__1aNQh","subtitle":"Home_subtitle__Qo4hN"};